import { render, staticRenderFns } from "./SelectItemColor.vue?vue&type=template&id=621a1aef"
import script from "./SelectItemColor.vue?vue&type=script&lang=js"
export * from "./SelectItemColor.vue?vue&type=script&lang=js"
import style0 from "./SelectItemColor.vue?vue&type=style&index=0&id=621a1aef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports